import { render, staticRenderFns } from "./mailverwaltung.vue?vue&type=template&id=767f94e4&scoped=true&"
import script from "./mailverwaltung.vue?vue&type=script&lang=js&"
export * from "./mailverwaltung.vue?vue&type=script&lang=js&"
import style0 from "./mailverwaltung.vue?vue&type=style&index=0&id=767f94e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f94e4",
  null
  
)

export default component.exports